<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div class="pageTitle mb-1 mt-1">
      {{ "cocmailBox.titleList" | translate }}
    </div>
    <div class="pageTitle collapsibleTitle">
      <div class="collapseButtonContainer">
        <h5 class="nobutton">En trámite</h5>
      </div>
    </div>

    <div class="filterTableContainer">
      <app-filters
        #outTable
        [filterList]="filterListOutTable"
        [options]="optionsFiltersOutTable"
        [type]="'buzon'"
        (showfilterButtons)="toggleFilterButtons($event)"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-filters
        #insideTable
        [filterList]="filterList"
        [options]="options"
        [ngClass]="{ filterHidden: !showTableFilter }"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-table
        [tableList]="tableList"
        [elementList]="cocList"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons]="showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
      ></app-table>
    </div>
  </div>
</div>
